export const mapToSelectOption = (item, index) => {
  const firstStringValue = Object.values(item).find(
    (value) => typeof value === "string" && value.trim() !== "",
  );

  const label =
    item.naziv
    || item.ime
    || item.nazivProjekta
    || item.projekt
    || item.partner
    || item.clanica
    || item.value
    || item.label
    || firstStringValue;

  const value =
    item.id
    || item.objectID
    || item.partnerID
    || item.clanicaID
    || item.projektID
    || label
    || index;

  return {
    name: String(label ?? ""),
    value: String(value),
  };
};

export const mapProjectToSelectOption = (item, index) => ({
  ...mapToSelectOption(item, index),
  zacetek:
    item.Zacetek
    || item.zacetek
    || item.datumZacetek
    || item.datum_zacetek
    || null,
});

export const normalizeDateToInput = (dateValue) => {
  if (!dateValue) {
    return "";
  }

  if (/^\d{4}-\d{2}-\d{2}/.test(dateValue)) {
    return dateValue.slice(0, 10);
  }

  const date = new Date(dateValue);
  if (!Number.isNaN(date.getTime())) {
    return date.toISOString().slice(0, 10);
  }

  const slovenianDateMatch = String(dateValue).match(/^((\d{1,2}))\.((\d{1,2}))\.(\d{4})$/);
  if (slovenianDateMatch) {
    const day = slovenianDateMatch[2].padStart(2, "0");
    const month = slovenianDateMatch[4].padStart(2, "0");
    const year = slovenianDateMatch[5];
    return `${year}-${month}-${day}`;
  }

  return "";
};

export const parseAmount = (value) => {
  if (value === "" || value === null || value === undefined) {
    return null;
  }

  const normalizedValue = String(value).replace(",", ".");
  const parsed = Number(normalizedValue);

  if (Number.isNaN(parsed)) {
    return null;
  }

  return parsed;
};

export const mapDeminimisDetailResponse = (response) => ({
  id: response.id ?? response.ID ?? null,
  prejemnikId: response.prejemnikId ?? response.PrejemnikId ?? null,
  prejemnik: String(response.prejemnik ?? response.Prejemnik ?? "-").trim(),
  dajalecId: response.dajalecId ?? response.DajalecId ?? null,
  dajalec: String(response.dajalec ?? response.Dajalec ?? "-").trim(),
  projektId: response.projektId ?? response.ProjektId ?? null,
  projekt: String(response.projekt ?? response.Projekt ?? "-").trim(),
  datumNacrtovanePomoci:
    response.datumNacrtovanePomoci ?? response.DatumNacrtovanePomoci ?? null,
  nacrtovanaVrednost:
    response.nacrtovanaVrednost ?? response.NacrtovanaVrednost ?? null,
  pomocOdobrena: Boolean(response.pomocOdobrena ?? response.PomocOdobrena),
  datumOdobritve: response.datumOdobritve ?? response.DatumOdobritve ?? null,
  visinaOdobrenePomoci:
    response.visinaOdobrenePomoci ?? response.VisinaOdobrenePomoci ?? null,
  pravnaPodlaga: response.pravnaPodlaga ?? response.PravnaPodlaga ?? "",
  stevilkaPriglasitve:
    response.stevilkaPriglasitve ?? response.StevilkaPriglasitve ?? "",
});

export const buildProjectDefaultOptions = (detail) => {
  if (!detail?.projektId || !detail?.projekt) {
    return [];
  }

  return [{ name: String(detail.projekt), value: String(detail.projektId) }];
};

export const buildDetailFormData = (detail) => ({
  prejemnikID: String(detail?.prejemnikId ?? ""),
  dajalecID: String(detail?.dajalecId ?? ""),
  projektID: String(detail?.projektId ?? ""),
  datumNacrtovanePomoci: normalizeDateToInput(detail?.datumNacrtovanePomoci),
  nacrtovanaVrednost: String(detail?.nacrtovanaVrednost ?? ""),
  datumOdobritve: normalizeDateToInput(detail?.datumOdobritve),
  visinaPomoci: String(detail?.visinaOdobrenePomoci ?? ""),
  pravnaPodlaga: String(detail?.pravnaPodlaga ?? ""),
  stevilkaPriglasitve: String(detail?.stevilkaPriglasitve ?? ""),
});
